const state = {
    loadingStates: {}, // Object to store multiple loading states
    taskIds: {}, // Store task IDs for each item
    taskTypes: {}, // Store task types (e.g., 'renewable', 'session', 'charger')
    taskStatuses: {}, // Store task statuses
    taskStartTimes: {}, // Store when each task started
  };
  
  const getters = {
    isLoading: (state) => (itemKey) => state.loadingStates[itemKey] || false,
    getTaskId: (state) => (itemKey) => state.taskIds[itemKey] || null,
    getTaskType: (state) => (itemKey) => state.taskTypes[itemKey] || null,
    getTaskStatus: (state) => (itemKey) => state.taskStatuses[itemKey] || null,
    getTaskStartTime: (state) => (itemKey) => state.taskStartTimes[itemKey] || null,
    
    // Helper getters for specific task types

    // INSIGHTS - Sessions: (export unallocated sessions)
    isSessionProcessing: (state) => state.loadingStates['session'] || false,

    // OPERATION - Session upload: (update session data)
    isSessionUploadProcessing: (state) => state.loadingStates['session_upload'] || false,

    // OPERATION - Onsite Renewables upload: (upload onsite renewables data)
    isOnsiteRenewablesUploadProcessing: (state) => state.loadingStates['onsite_renewables_upload'] || false,

    // SUPPORT - Charger
    isChargerProcessing: (state) => state.loadingStates['charger'] || false,

    // OPERATION - Abatement calculate: (calculate abatement)
    isAbatementCalculateProcessing: (state) => state.loadingStates['abatement_calculate'] || false,

    // Dashboard home highlights (async Celery + cache)
    isDashboardHighlightsProcessing: (state) => state.loadingStates['dashboard_highlights'] || false,

    // INSIGHTS - Auditor / Verra reports (async Celery report tables)
    isAuditorReportsProcessing: (state) => state.loadingStates['auditor_reports'] || false,
    isVerraReportsProcessing: (state) => state.loadingStates['verra_reports'] || false,

    // OPERATION - UK emission intensity update: (update uk emission intensity)
    isUkEmissionIntensityUpdateProcessing: (state) => state.loadingStates['uk_emission_intensity_update'] || false,
    
    // Get all currently processing tasks
    getProcessingTasks: (state) => {
      return Object.keys(state.loadingStates).filter(key => state.loadingStates[key]);
    },
  };
  
  const mutations = {
    SET_LOADING_STATE(state, { itemKey, isLoading, taskId = null, taskType = null, status = 'PENDING' }) {
      if (isLoading) {
        state.loadingStates[itemKey] = true;
        if (taskId) state.taskIds[itemKey] = taskId;
        if (taskType) state.taskTypes[itemKey] = taskType;
        state.taskStatuses[itemKey] = status;
        state.taskStartTimes[itemKey] = new Date();
      } else {
        state.loadingStates[itemKey] = false;
        delete state.taskIds[itemKey];
        delete state.taskTypes[itemKey];
        delete state.taskStatuses[itemKey];
        delete state.taskStartTimes[itemKey];
      }
    },
    
    UPDATE_TASK_STATUS(state, { itemKey, status }) {
      if (state.loadingStates[itemKey]) {
        state.taskStatuses[itemKey] = status;
      }
    },
    
    CLEAR_ALL_LOADING_STATES(state) {
      state.loadingStates = {};
      state.taskIds = {};
      state.taskTypes = {};
      state.taskStatuses = {};
      state.taskStartTimes = {};
    },
    
    CLEAR_LOADING_STATE(state, itemKey) {
      delete state.loadingStates[itemKey];
      delete state.taskIds[itemKey];
      delete state.taskTypes[itemKey];
      delete state.taskStatuses[itemKey];
      delete state.taskStartTimes[itemKey];
    },
  };
  
  const actions = {
    startLoading({ commit }, { itemKey, taskId, taskType, status = 'PENDING' }) {
      commit('SET_LOADING_STATE', { 
        itemKey, 
        isLoading: true, 
        taskId, 
        taskType, 
        status 
      });
    },
    
    stopLoading({ commit }, itemKey) {
      commit('SET_LOADING_STATE', { itemKey, isLoading: false });
    },
    
    updateTaskStatus({ commit }, { itemKey, status }) {
      commit('UPDATE_TASK_STATUS', { itemKey, status });
    },
    
    completeTask({ commit }, itemKey) {
      commit('UPDATE_TASK_STATUS', { itemKey, status: 'SUCCESS' });
      // Auto-clear after 1 second
      setTimeout(() => {
        commit('CLEAR_LOADING_STATE', itemKey);
      }, 1000);
    },
    
    failTask({ commit }, itemKey) {
      commit('UPDATE_TASK_STATUS', { itemKey, status: 'FAILURE' });
      // Auto-clear after 1 second
      setTimeout(() => {
        commit('CLEAR_LOADING_STATE', itemKey);
      }, 1000);
    },
    
    clearAllLoading({ commit }) {
      commit('CLEAR_ALL_LOADING_STATES');
    },
    
    clearLoadingState({ commit }, itemKey) {
      commit('CLEAR_LOADING_STATE', itemKey);
    },
  };
  
  export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
  };